import userApi from "../../api/userApi";

const state = {
    user: {},
    errors: [],
    notifications: [],
    notification: {},
};
const actions = {
    async getUser({ commit }) {
        const res = await userApi.retrieve().catch((err) => {
            console.log(err);
            return false;
        });

        if (res.status === 200) {
            commit("SET_USER", res.data);
            return true;
        }
    },
    async logoutAdmin({ commit }) {
        const res = await userApi.logoutUser()
            .catch((err) => {
                console.log(err);
                return false;
            });

        if (res.status === 200) {
            commit("SET_CURRENT_USER", res.data);
            return true;
        }
    },
    async userNotifications({ commit }) {
        return new Promise((resolve, reject) => {
            userApi.getAllNotifications()
            .then((response) => {
                if (response.status == 200) {
                    commit("SET_NOTIFICATIONS", response.data);
                    resolve(response);
                }
                reject(response);
            })
            .catch((error) => {
                reject(error);
            })
        })
    },
    async sendNotif({ commit }, notif) {
        return new Promise((resolve, reject) => {
            userApi.sendNotif(notif)
            .then((response) => {
                if (response.status == 201) {
                    commit("ADD_NOTIFICATION", response.data);
                    resolve(response);
                }
                reject(response);
            })
            .catch((error) => {
                reject(error)
            });
        })
    },
    async getNotifById({ commit }, notificationID) {
        return new Promise((resolve, reject) => {
            userApi
                .delaynotif(notificationID)
                .then((response) => {
                    if (response.status === 200) {
                        commit("SET_NOTIFICATION", response.data);
                        resolve(response);
                    }
                    reject(response);
                })
                .catch((err) => {
                    reject(err);
                })
        })
    },
    async updateNotification({ commit }, notificationID) {
        const res = await userApi.updateNotifications(notificationID)

        if (res.status === 200) {
            commit('UPDATE_NOTIFICATION', res.data);
            return true;
        }
    },
};

const mutations = {
    SET_USER: (state, user) => state.user = user,
    ADD_NOTIFICATION: (state, notification) => state.notifications.unshift(notification),

    SET_NOTIFICATION: (state, notification) => (state.notification = notification),

    SET_NOTIFICATIONS: (state, notifications) => state.notifications = notifications,

    CLEAR_NOTIFICATIONS: (state) => state.notifications = {},

    SET_CURRENT_USER: (state, currentUser) => (state.currentUser = currentUser),

    UPDATE_NOTIFICATION: (state, notification) => {
        const index = state.notifications.findIndex((notification) => notification.id === notification.id);

        if (index !== -1) {
            state.notifications.splice(index, 1, notification);
        }
    },


    SET_ERRORS: (state, errors) => (state.errors = errors),
};


export default { 
    state, 
    actions, 
    mutations 
};